import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=5842f46e&scoped=true&lang=pug&"
import script from "./Checkout.vue?vue&type=script&lang=js&"
export * from "./Checkout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5842f46e",
  null
  
)

export default component.exports